import { render, staticRenderFns } from "./Overpayment.vue?vue&type=template&id=b2457484&scoped=true"
import script from "./Overpayment.vue?vue&type=script&lang=js"
export * from "./Overpayment.vue?vue&type=script&lang=js"
import style0 from "./Overpayment.vue?vue&type=style&index=0&id=b2457484&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2457484",
  null
  
)

export default component.exports